module.exports = __webpack_public_path__ + "media/כוס.a479a1cf.mp3";